import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';

/**
 * Custom translation loader that fetches translations from the iOnCourt API
 * instead of using local JSON files. This allows for dynamic translation updates
 * without requiring app updates.
 * 
 * API Endpoint: https://dev-api.ioncourt.com/api/i18n?ns=common&locale={lang}
 */
@Injectable({
  providedIn: 'root'
})
export class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  /**
   * Fetches translations for the specified language from the API
   * @param lang The language code (e.g., 'en', 'hi', 'sr')
   * @returns Observable containing the translation object
   */
  getTranslation(lang: string): Observable<any> {
    const url = 'api_endpoint' + `/i18n?ns=common&locale=${lang}`;
    return this.http.get(url);
  }
}
